import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT_SETTINGS = {
  address: "6241 University Dr NW, Huntsville, AL",
  phone: "(256) 489-3274",
  hours: [
    { day: "Lunch · Tue – Fri", time: "11am – 3pm" },
    { day: "Dinner · Tue – Thu", time: "3pm – 10pm" },
    { day: "Brunch · Sat – Sun", time: "11am – 4pm" },
    { day: "Fri – Sat", time: "11am – 12am" },
    { day: "Monday", time: "Closed" },
  ],
  hero_subheadline:
    "Come hungry. Stay for the vibe. Soul food the way grandma did it, stiff drinks the way the bartender wants to, and a room that feels like home — right here on University in Huntsville.",
  marquee_items: [
    "Taco Tuesdays",
    "That's My Jam · R&B Wednesdays",
    "Taste Thursdays",
    "Finally Friday · The After-Work Destination",
    "Saturday Brunch · Official Pregame Happy Hour 4–8",
    "Soul Food Sundays · Brunch + Dinner",
    "Eat. Drink. Vibe.",
  ],
  group_cta_overline: "You or your friend turning up?",
  group_cta_headline: "Birthday plans? Bring the whole crew.",
  group_cta_body:
    "Big table, big party, big night. Drop the basics and we'll call you back to lock it in — drinks, decor, the bottle parade, whatever you need.",
  footer_tagline: "Eat. Drink. Vibe.",
  maintenance_mode: false,
};

const SettingsContext = createContext(DEFAULT_SETTINGS);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setSettings({ ...DEFAULT_SETTINGS, ...r.data }))
      .catch(() => {});
  }, []);
  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
